import React from 'react';

const UpdateScreen = () => {
    return <></>;
}

export default UpdateScreen;